import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { AiOutlinePlus } from "react-icons/ai";
import Navbar from "../../components/universal/Navbar";
import SearchBar from "../../components/universal/SearchBar";
import CustomTable from "../../components/universal/CustomTable";
import { toast } from "react-toastify";
import { agreementsHeaders, ENTITY_TYPE_LABELS } from "./Constants";
import {
  readAgreementsRequest,
  deleteAgreementRequest,
} from "../../store/Agreements/agreementsActions";

const AgreementsAll = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [reloadData, setReloadData] = useState(false);
  const [entityType, setEntityType] = useState("1");

  const normalizeRows = (list = []) =>
    list.map((item) => ({
      ...item,
      _raw: item,
      entityType: ENTITY_TYPE_LABELS[String(item?.typeofentity || "")] || "-",
      active: String(item?.isActive) === "true" ? 1 : 0,
    }));

  const filterRows = (rows, criteria) => {
    const values = Object.values(criteria || {}).filter(Boolean);
    if (values.length === 0) return rows;
    const query = String(values[0]).toLowerCase();
    return rows.filter((row) =>
      [row?.agreementTitle, row?.agreementType, row?.entityType, row?.agreementText]
        .map((val) => String(val || "").toLowerCase())
        .some((val) => val.includes(query))
    );
  };

  const fetchAgreements = (page, limit, criteria = {}, callbackFn) => {
    dispatch(
      readAgreementsRequest({ typeofentity: entityType }, (res) => {
        const items = res?.type === 1 ? res?.data || [] : [];
        const normalized = normalizeRows(items);
        const filtered = filterRows(normalized, criteria);
        if (callbackFn) {
          callbackFn({
            data: filtered,
            total: filtered.length,
            pageNum: page,
          });
        }
      })
    );
  };

  useEffect(() => {
    setReloadData(true);
  }, [entityType]);

  const handleDelete = (row) => {
    if (!row?._id && !row?.agreementType) return;
    dispatch(
      deleteAgreementRequest({ _id: row?._id, agreementType: row?.agreementType }, (res) => {
        if (res?.type === 1) {
          toast.success("Agreement deleted");
          setReloadData(true);
        } else {
          toast.error(res?.error || "Delete failed");
        }
      })
    );
  };

  const handleEdit = (row) => {
    navigate("/agreements/add", { state: { agreement: row?._raw || row } });
  };

  return (
    <div className="App bg-[#191919] h-fit min-h-screen flex p-4">
      <Navbar />
      <div className="flex-1 md:pl-32 md:pt-0 pt-20">
        <div className="flex flex-col gap-4 h-full">
          <SearchBar placeholder={"Search"} value={""} onChangeSearchBar={() => {}} />
          <div className="MAIN-CONTENT flex-1 flex flex-col h-full gap-4">
            <div className="flex w-full justify-between md:items-center md:flex-row flex-col gap-4 md:mb-0 mb-2">
              <div className="flex justify-between items-center flex-1">
                <p className="text-white text-3xl font-medium">Agreements</p>
              </div>
              <div className="flex gap-4">
                <Link to="/agreements">
                  <button className="text-[13px] text-greyish border px-4 py-2 border-greyish bg-blackish rounded-xl">
                    Back to Analytics
                  </button>
                </Link>
                <Link to="/agreements/add">
                  <button className="flex items-center gap-2 text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl">
                    <AiOutlinePlus /> Add Agreement
                  </button>
                </Link>
              </div>
            </div>

            <div className="bg-blackish rounded-xl p-4">
              <div className="flex flex-col md:flex-row gap-4 md:items-end mb-4">
                <div className="w-full md:w-64">
                  <label className="text-[12px] text-greyish font-medium">Entity Type</label>
                  <select
                    value={entityType}
                    onChange={(e) => setEntityType(e.target.value)}
                    className="bg-blackish p-2 w-full text-white text-[14px] mt-2 rounded-md h-10"
                  >
                    <option value="1">Church</option>
                    <option value="2">Channel</option>
                    <option value="3">Ministry</option>
                  </select>
                </div>
              </div>

              <CustomTable
                searchFor="Agreements"
                width={"w-28"}
                nthChildWidth={"[&>*:nth-child(1)]:w-56 [&>*:nth-child(3)]:w-[420px]"}
                nthChildColor={
                  "[&>*:nth-child(2)]:text-greyish [&>*:nth-child(3)]:text-greyish [&>*:nth-child(4)]:text-greyish"
                }
                data={[]}
                headers={agreementsHeaders}
                customDataFetch={true}
                customDataFetchFunction={fetchAgreements}
                reloadData={reloadData}
                setReloadData={setReloadData}
                reverseTable={true}
                handleEditClick={handleEdit}
                handleDeleteClick={handleDelete}
                notificationTable={true}
                heightDesktop={"h-[72vh]"}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgreementsAll;
